import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const DiscLensProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="DiSC Lens™ Assessment Nigeria | Three-Lens DISC Profile Lagos"
        description="Take the DiSC Lens™ assessment online. RESILIGENT's adaptive three-lens DISC framework measuring how you act, what you value, and what motivates you. Purpose-built for African leadership contexts."
        keywords="DiSC Lens Nigeria, DISC assessment Lagos, three-lens DISC, behavioural assessment Nigeria, leadership assessment Africa, DISC profile online"
        canonical="https://impactasportal.com/product/disc-lens"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/disc-lens?embed=true"
            title="DiSC Lens™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default DiscLensProductPage;
